import { format } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

export const getTransformedDate = (date: string, dateFormat?: string) => {
  const formatedDate = format(fromZonedTime(date, 'UTC'), dateFormat ?? 'dd/MM/yyyy HH:mm:SS');
  return formatedDate;
};
